import imageUrlBuilder from '@sanity/image-url'
import type { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder'
import type {
  AutoMode,
  FitMode,
  SanityImageObject,
  SanityImageSource,
} from '@sanity/image-url/lib/types/types'

import clientConfig from '../../../client-config'
import { Maybe, SanityImageObjectFragment } from '../../graphql/gatsby'
import { logAndCaptureException } from '../../utils/errorTools'
import { dispensariesSanityConfig } from './config'

export interface ImageUrlOptions {
  width?: number
  height?: number
  dpr?: number
  autoMode?: AutoMode
  fit?: FitMode
}

const builder = imageUrlBuilder(clientConfig.sanity)

export const imageUrlFor = (source: SanityImageSource): ImageUrlBuilder => {
  return builder.image(source)
}

export function isSanityImageObject(
  value: Maybe<SanityImageObjectFragment> | undefined,
): value is Extract<SanityImageObject, { asset: { _id: string } }> {
  return !!value?.asset?._id
}

export const getResizedImageUrl = (
  source: SanityImageSource,
  { width, height, autoMode, dpr, fit }: ImageUrlOptions = {},
): string | null => {
  let imageBuilder = imageUrlFor(source)
  imageBuilder = imageBuilder.auto(autoMode || 'format')
  if (width) {
    imageBuilder = imageBuilder.width(width)
  }
  if (height) {
    imageBuilder = imageBuilder.height(height)
  }
  if (dpr) {
    imageBuilder = imageBuilder.dpr(dpr)
  }
  if (fit) {
    imageBuilder = imageBuilder.fit(fit)
  }
  return imageBuilder.url()
}

export const tryParsingSanityImageJson = (
  sanityImageJson: string,
): SanityImageSource | undefined => {
  try {
    return JSON.parse(sanityImageJson)
  } catch (err) {
    logAndCaptureException(new Error(`Error parsing sanityImageJson: ${err}\n${sanityImageJson}`), {
      level: 'warning',
    })
    return undefined
  }
}

const dispensaryBuilder = imageUrlBuilder(dispensariesSanityConfig)

export function dispensaryImageUrlFor(source: SanityImageSource): ImageUrlBuilder {
  return dispensaryBuilder.image(source)
}
